<template>
  <div class="addLeaderInfo">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <!-- 项目负责人信息 -->
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item tem label="负责人姓名" prop="leaderName">
          <el-input v-model="ruleForm.leaderName" placeholder="请输入负责人姓名" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="证件类型" prop="certificateType">
          <el-select v-model="ruleForm.certificateType" placeholder="请选择">
            <el-option v-for="item in certificateType" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem label="身份证号" prop="leaderIdCardNum">
          <el-input v-model="ruleForm.leaderIdCardNum" placeholder="请输入身份证号" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-form-item tem label="手机号码" prop="leaderPhoneNum">
          <el-input v-model="ruleForm.leaderPhoneNum" placeholder="请输入电话号码" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="save('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_save')}}
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:addLeaderInfo
   *@Description:小区负责人管理
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        isDisabled: true, // 保存的可点击
        certificateType: this.$i18n.t('lang.certificateType'),
        saveData: '',
        rules: {
          leaderName: [{
            required: true,
            message: '请输入负责人姓名',
            trigger: 'blur'
          }],
          certificateType: [{
            required: true,
            message: '请选择证件类型',
            trigger: 'change'
          }],
          leaderIdCardNum: [{
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur'
          }],
          leaderPhoneNum: [{
            required: true,
            message: '请输入电话号',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          leaderName: '', // 负责人姓名
          certificateType: '', // 证件类型
          leaderIdCardNum: '', // 负责人身份证号
          leaderPhoneNum: '', // 负责人电话号

        },
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    created() {
      this.getData()
    },
    methods: {
      back() {
        this.$router.push({
          name: 'projectPortrait'
        })
      },
      // 获取详情数据
      getData() {
        let loading = this.$loading()
        this.$get(`/gardenDrawGardenLeader?gardenId=${this.gardenId}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.list.length > 0) {
                this.ruleForm.leaderName = res.list[0].leaderName
                this.ruleForm.certificateType = res.list[0].certificateType
                this.ruleForm.leaderIdCardNum = res.list[0].leaderIdCardNum
                this.ruleForm.leaderPhoneNum = res.list[0].leaderPhoneNum
                this.id = res.list[0].id
                // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
                this.saveData = JSON.stringify(this.ruleForm)
                console.log(this.ruleForm)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 保存
      save(formName) {
        let params = this.ruleForm
        params.gardenId = this.gardenId
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (!this.id) {
              // 新增
              this.$post('/gardenDrawGardenLeader', params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              // 编辑
              this.$patch(`/gardenDrawGardenLeader/${this.id}`, params).then(
                res => {
                  loading.close()
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.isDisabled = true
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 项目负责人信息清空
      resetForm(formName) {
        this.ruleForm.leaderName = ''
        this.ruleForm.certificateType = ''
        this.ruleForm.leaderIdCardNum = ''
        this.ruleForm.leaderPhoneNum = ''
      },
    },
  }
</script>

<style lang="scss">
  .addLeaderInfo {
    .flexBox {
      display: flex;

      .el-tabs {
        background-color: #fff !important;
        flex: 1;
      }

      .el-tabs__nav-wrap {
        // width: 99%!important;
        position: static !important;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:nth-last-child(2) {
        padding-left: 20px !important;
      }

      .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item:last-child {
        padding-right: 20px !important;
      }
    }

    .item-input,
    .el-select,
    .el-date-editor.el-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }
  }
</style>